<template>
    <div>
        <v-card elevation="0">
            <v-card-subtitle>
                This information will be used to auto-fill some of the application forms for you. 
                You will be able to edit the following information in here as well as in the application form.
            </v-card-subtitle>
            <v-card-text v-if="profileloading">
                <div style="height: 400px;">
                    <v-row
                        class="fill-height"
                        align-content="center"
                        justify="center"
                    >
                        <v-col
                            class="text-subtitle-1 text-center"
                            cols="12"
                        >
                            Getting your information...
                        </v-col>
                        <v-col cols="6">
                        <v-progress-linear
                            indeterminate
                            color="#00ACC1"
                        ></v-progress-linear>
                        </v-col>
                    </v-row>
                </div>
            </v-card-text>
            <v-card-text v-else>
                <v-icon>mdi-alert-circle-outline</v-icon>&nbsp;Updates will not be saved until "Save Changes" button is clicked.
                <v-tabs v-model="tab" background-color="transparent" color="#00ACC1" grow>
                    <v-tab v-for="item in tabitems" :key="item">
                        {{ item }}
                    </v-tab>
                </v-tabs>
                <v-card elevation="0" height="3px" color="#00ACC1" tile></v-card>
                <v-tabs-items v-model="tab">
                    <v-tab-item>
                        <v-card elevation="0">
                            <v-card-text>
                                <v-row>
                                    <v-col cols="4">
                                        <v-text-field label="First Name" outlined v-model="firstname" :disabled="!enableEdit" hide-details></v-text-field>
                                    </v-col>
                                    <v-col cols="4">
                                        <v-text-field label="Last Name" outlined v-model="lastname" :disabled="!enableEdit" hide-details></v-text-field>
                                    </v-col>
                                    <v-col cols="4">
                                        <v-text-field label="Preferred Name" outlined v-model="preferredname" :disabled="!enableEdit" hide-details></v-text-field>
                                    </v-col>
                                    <v-col cols="12">
                                        <v-text-field label="Street Address" outlined v-model="address.street" :disabled="!enableEdit" hide-details></v-text-field>
                                    </v-col>
                                    <v-col cols="4">
                                        <v-text-field label="City" outlined v-model="address.city" :disabled="!enableEdit" hide-details></v-text-field>
                                    </v-col>
                                    <v-col cols="4">
                                        <v-text-field label="Province" outlined v-model="address.province" :disabled="!enableEdit" hide-details></v-text-field>
                                    </v-col>
                                    <v-col cols="4">
                                        <v-text-field label="Postal Code" outlined v-model="address.postalcode" :disabled="!enableEdit" hide-details></v-text-field>    
                                    </v-col>
                                    <v-col cols="6">
                                        <v-text-field label="Home Phone" outlined v-model="homephone" :disabled="!enableEdit" hide-details></v-text-field>
                                    </v-col>
                                    <v-col cols="6">
                                        <v-text-field label="Cell Phone" outlined v-model="cellphone" :disabled="!enableEdit" hide-details></v-text-field>
                                    </v-col>
                                    <v-col cols="12">Checked email will be your preferred email. Please make sure your preferred email is active to use.</v-col>
                                    <v-col cols="5">
                                        <v-row>
                                            <v-checkbox
                                                v-model="preferredemail"
                                                true-value="email"
                                                false-value="western"
                                                :disabled="!enableEdit"
                                                hide-details
                                            ></v-checkbox>
                                            <v-text-field disabled label="Email Address" outlined v-model="email"></v-text-field>
                                        </v-row>
                                    </v-col>
                                    <v-col cols="1"></v-col>
                                    <v-col cols="5">
                                        <v-row>
                                            <v-checkbox
                                                v-model="preferredemail"
                                                true-value="western"
                                                false-value="email"
                                                :disabled="!(/uwo.ca$/.test(westernemail)) || !enableEdit"
                                                hide-details
                                            ></v-checkbox>
                                            <v-text-field label="Western Email Address" outlined v-model="westernemail" :disabled="!enableEdit" :rules="[rules.email]"></v-text-field>
                                        </v-row>
                                    </v-col>
                                    <v-col cols="1"></v-col>
                                </v-row>
                            </v-card-text>
                        </v-card>
                    </v-tab-item>
                    <v-tab-item>
                        <v-card elevation="0">
                            <v-card-subtitle>Maximum of 5 entries. Please list the highest degree first</v-card-subtitle>
                            <v-card-text>
                                <v-row>
                                    <v-col cols="6" v-for="(count, i) in educationcount" :key="i">
                                        <v-row>
                                            <v-col cols="12">Entry #{{count}}</v-col>
                                            <v-col cols="12"><v-text-field label="Degree" outlined v-model="education[count-1].degree" hide-details :disabled="!enableEdit" dense></v-text-field></v-col>
                                            <v-col cols="12"><v-text-field label="University Attended" outlined v-model="education[count-1].university" hide-details :disabled="!enableEdit" dense></v-text-field></v-col>
                                            <v-col cols="12"><v-select label="Status" :items="educationitems" outlined v-model="education[count-1].status" hide-details :disabled="!enableEdit" dense></v-select></v-col>
                                            <v-col cols="12"><v-text-field label="Area of Specialization" outlined v-model="education[count-1].specialization" hide-details :disabled="!enableEdit" dense></v-text-field></v-col>
                                        </v-row>
                                    </v-col>
                                    <v-col cols="12">
                                        <v-btn text color="#00ACC1" @click="addEducationalHistory" v-if="addmoreeducation" outlined :disabled="!enableEdit">Add another Educational History Entry</v-btn>
                                    </v-col>
                                </v-row>
                            </v-card-text>
                        </v-card>
                    </v-tab-item>
                    <v-tab-item>
                        <v-card elevation="0">
                            <v-card-subtitle>Valid only if previously taught at King's</v-card-subtitle>
                            <v-card-text>
                                <v-row>
                                    <v-col cols="8">
                                        <v-text-field label="Employee Number (if known)" outlined v-model="employment.employeenumber" hide-details :disabled="!enableEdit"></v-text-field>
                                    </v-col>
                                    <v-col cols="12">
                                        <v-textarea height="130px" label="Course(s) taught at King's (if applicable)" outlined v-model="employment.courses" hide-details :disabled="!enableEdit"></v-textarea>
                                    </v-col>
                                </v-row>
                            </v-card-text>
                        </v-card>
                    </v-tab-item>
                    <v-tab-item>
                        <v-card elevation="0">
                            <v-card-text>
                                <v-row>
                                    <v-col cols="6" v-for="(count, i) in 3" :key="i">
                                        <v-row>
                                            <v-col cols="12">Reference {{count}}</v-col>
                                            <v-col cols="12"><v-text-field label="Name" outlined v-model="references[count-1].name" hide-details :disabled="!enableEdit" dense></v-text-field></v-col>
                                            <v-col cols="12"><v-text-field label="Academic Affiliation" outlined v-model="references[count-1].academicaffiliation" hide-details :disabled="!enableEdit" dense></v-text-field></v-col>
                                            <v-col cols="12"><v-text-field label="Email Address" outlined v-model="references[count-1].email" hide-details :disabled="!enableEdit" dense></v-text-field></v-col>
                                            <v-col cols="12"><v-text-field label="Phone" outlined v-model="references[count-1].phone" hide-details :disabled="!enableEdit" dense></v-text-field></v-col>
                                        </v-row>
                                    </v-col>
                                </v-row>

                            </v-card-text>
                        </v-card>
                    </v-tab-item>
                </v-tabs-items>
            </v-card-text>
            <v-card-actions v-if="!profileloading">
                <v-spacer></v-spacer>
                <v-row justify="end">
                    <v-dialog
                        v-model="dialog"
                        persistent
                        max-width="450"
                    >
                        <template v-slot:activator="{ on, attrs }">
                            <v-btn
                                color="#004236"
                                outlined
                                v-bind="attrs"
                                class="ma-4"
                                v-on="on"
                                :disabled="!enableEdit"
                            >
                                Save Changes
                            </v-btn>
                        </template>
                        <v-card>
                            <v-toolbar color="#004236" dark elevation="0">
                                <v-toolbar-title>Update Profile Information?</v-toolbar-title>
                            </v-toolbar><br />
                            <v-card-text>
                                Updated profile information will be reflected in application forms.
                            </v-card-text>
                            <v-card-actions>
                                <v-spacer></v-spacer>
                                <v-btn
                                    color="#6d6e71"
                                    outlined dark
                                    @click="dialog = false"
                                >
                                    Cancel
                                </v-btn>
                                <v-btn
                                    color="#004236"
                                    outlined dark
                                    @click="editProfileDetails"
                                    :loading="loading"
                                >
                                    Save
                                </v-btn>
                            </v-card-actions>
                        </v-card>
                    </v-dialog>
                </v-row>
            </v-card-actions>
        </v-card>
        <v-snackbar
            v-model="snackbar"
            :color="snackbarcolor"
            :timeout="timeout"
        >
            {{ text }}
        </v-snackbar>
    </div>
</template>
<script>
import auth from "../../../js/auth"
export default {
    data(){
        return {
            host: location.hostname.toString(),
            tab: 0,
            tabitems: ["General", "Education", "Employment", "References"],
            id: "",
            firstname: "",
            lastname: "",
            preferredname: "",
            address: {
                street: "",
                city: "",
                province: "",
                postalcode: ""
            },
            rules: {
                email: v => /^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/.test(v) && /uwo.ca$/.test(v)|| "Invalid Western email format"
            },
            homephone: "",
            cellphone: "",
            email: "",
            westernemail: "",
            preferredemail: "",
            educationitems: ['Please select...', 'Completed', 'ABD - Active In Program', 'Discontinued'],
            educationcount: 1,
            addmoreeducation: true,
            education: [{
                "degree": "",
                "university": "",
                "status": "Please select...",
                "specialization": ""
            }],
            employment: {
                "employeenumber": "",
                "courses": ""
            },
            references: [
                {"name" : "", "academicaffiliation": "", "email": "", "phone": "",},
                {"name" : "", "academicaffiliation": "", "email": "", "phone": "",},
                {"name" : "", "academicaffiliation": "", "email": "", "phone": "",}
            ],
            snackbar: false,
            snackbarcolor: "",
            text: "",
            timeout: 3500,
            loading: false,
            profileloading: true,
            dialog: false,
            enableEdit: true,
        }
    },
    methods: {
        getProfileDetails(){
            const that = this;

            //Session Reading
            let user = "";
            if(sessionStorage.getItem('cupeapp_aaa')){
                user = auth.get_impersonated_user();
                that.enableEdit = false;
            }else {
                user = auth.get_user();
                that.enableEdit = true;
            }


            let api = 'https://'+that.host+'/cgi-bin/cupe-app-api/api.py?mode=getprofile&data={"uid":"'+user["uid"]+'"}';
            that.profileloading = true;
            //API calling
            fetch(api)
                .then(function (response) {
                    return response.json();
                })
                .then(function (resultData) {
                    if(!resultData.result.match(/^OK/i)){
                        that.setSnackbar("Warning: "+resultData.message, "#EF6C00"); //orange
                    }else {
                        let result = resultData["data"][0];
                        that.firstname = result["firstname"];
                        that.lastname = result["lastname"];
                        that.preferredname = result["preferredname"];
                        if(result["address"]){
                            that.address = result["address"];
                        }
                        if(result["phone"]){
                            that.homephone = result["phone"]["home"];
                            that.cellphone = result["phone"]["cell"];
                        }
                        that.email = result["email"];
                        if(result["westernemail"]){
                            that.westernemail = result["westernemail"];
                        }

                        that.preferredemail = result["preferredemail"];

                        that.id=result["id"];

                        if(result["education"] && result["education"].length > 0){
                            that.education = result["education"];
                            that.educationcount = result["education"].length;
                        }else {
                            that.education = [{
                                "degree": "",
                                "university": "",
                                "status": "Please select...",
                                "specialization": ""
                            }];
                            that.educationcount = 1;
                        }

                        if(result["employment"]){
                            that.employment = result["employment"]
                        }else {
                            that.employment = {
                                "employeenumber": "",
                                "courses": ""
                            }
                        }

                        if(result["references"]){
                            that.references = result["references"]
                        }else {
                            that.references = [
                                {"name" : "", "academicaffiliation": "", "email": "", "phone": "",},
                                {"name" : "", "academicaffiliation": "", "email": "", "phone": "",},
                                {"name" : "", "academicaffiliation": "", "email": "", "phone": "",}
                            ];
                        }
                    }

                    that.profileloading = false;
                })
                .catch(function(err){
                    that.setSnackbar("Error: "+err.toString(), "#E57373"); //light red
                })
            //End of API calling
        },
        addEducationalHistory(){
            const that = this;
            if(that.educationcount < 6){
                that.educationcount = that.educationcount+1;
                if(that.educationcount == 5){
                    that.addmoreeducation = false;
                }
                that.education.push({
                    "degree": "",
                    "university": "",
                    "status": "Please select...",
                    "specialization": ""
                });
            }
        },
        editProfileDetails(){
            const that = this;
            that.loading = true;
            let profile = {
                "id": that.id,
                "firstname" : that.firstname,
                "lastname" : that.lastname,
                "preferredname": that.preferredname,
                "address" : {
                    "street" : that.address.street,
                    "city" : that.address.city,
                    "province" : that.address.province,
                    "postalcode": that.address.postalcode
                },
                "phone": {
                    "home" : that.homephone,
                    "cell" : that.cellphone
                },
                "westernemail" : that.westernemail,
                "preferredemail" : that.preferredemail,
                "education" : that.education,
                "employment": that.employment,
                "references": that.references
            }

            let api = 'https://'+that.host+'/cgi-bin/cupe-app-api/api.py';

            const formData = new FormData();

            formData.append("mode", "setProfile");
            formData.append("data", JSON.stringify(profile));

            //API calling
            fetch(api,{
                    method: "POST",
                    body: formData
                })
                .then(function (response) {
                    return response.json();
                })
                .then(function (resultData) {
                    if(!resultData.result.match(/^OK/i)){
                        that.setSnackbar("Warning: "+resultData.message, "#EF6C00"); //orange
                    }else {
                        that.setSnackbar("Profile update successful!", "#388E3C"); //green
                    }

                    that.loading = false;
                    that.dialog = false;
                })
                .catch(function(err){
                    that.loading = false;
                    that.setSnackbar("Error: "+err.toString(), "#E57373"); //light red
                    that.dialog = false;
                })
            //End of API calling
        },
        setSnackbar(msg, color){ //Sets Snackbar
            const that = this;
            that.snackbar = true;
            that.snackbarcolor = color;
            that.text = msg;
        }
    },
    created(){
        const that = this;
        that.getProfileDetails();
    }
}
</script>